import { useScrollReset } from '@/hooks/useScrollReset';

const ScrollToTop = () => {
  useScrollReset();
  return null;
};

export default ScrollToTop; 
 
 
 
 